import { Storage } from "@lightningjs/sdk";
import { radiostations } from "../assets/radiostations";
import { getRadiostationsDataRequest } from "./api.service";
import { Store } from "./app.store.service";
export class RadiostationsService {
  static setRadiostations(radiostationsJSON) {
    this.radiostations = radiostationsJSON;
    Store.radiostations = radiostationsJSON;
  }

  static async initialize() {
    const radiostationsFromServer = await this.requestRadiostationsConfig().catch(error => {
      throw error;
    });

    if (radiostationsFromServer) {
      this.setRadiostations(radiostationsFromServer.radiostations);
      return radiostationsFromServer;
    } else {
      this.setRadiostations(radiostations);
      return radiostationsFromServer;
    }
  }

  static async requestRadiostationsConfig() {
    const response = await getRadiostationsDataRequest().catch(error => {
      throw error;
    });
    if (response && response.data) {
      return response.data;
    }
  }

  static getCurrentRadiostation() {
    return this.currentRadiostation;
  }

  static setCurrentRadiostation(radiostation) {
    this.currentRadiostation = radiostation;
    Storage.set("lastActivatedId", radiostation.id);
  }

  static getPreviouslyActiveRadiostation() {
    let previouslyActivatedRadioId = Storage.get("lastActivatedId");

    if (previouslyActivatedRadioId) {
      var latestActivatedIndex = this.findRadiostationIndex(previouslyActivatedRadioId);
      if (latestActivatedIndex != -1) {
        return latestActivatedIndex;
      } else {
        return 0;
      }
    } else {
      return 0;
    }
  }

  static findRadiostationIndex(radiostationId) {
    for (var i = 0; i < this.radiostations.length; i++) {
      if (this.radiostations[i].id == radiostationId) {
        return i;
      }
    }
    return -1;
  }
}
